import { render, staticRenderFns } from "./ykUpload.vue?vue&type=template&id=a80d1562"
import script from "./ykUpload.vue?vue&type=script&lang=js"
export * from "./ykUpload.vue?vue&type=script&lang=js"
import style0 from "./ykUpload.vue?vue&type=style&index=0&id=a80d1562&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\smartlink\\front\\lianhe\\ctruck-lock-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a80d1562')) {
      api.createRecord('a80d1562', component.options)
    } else {
      api.reload('a80d1562', component.options)
    }
    module.hot.accept("./ykUpload.vue?vue&type=template&id=a80d1562", function () {
      api.rerender('a80d1562', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/YkFormComponet/ykUpload.vue"
export default component.exports